/**
 * Is a newer version of the app live? (2026-10-13) An app that is already open — a browser tab or
 * the home-screen app on the family tablet — keeps running the version it loaded, so a fix that
 * went live isn't used until it is reloaded. The app compares its own main script with the one
 * the server's index.html points to now.
 */

/** The main script name in index.html, e.g. "main.f289ccb2.js", or null. */
export function mainBundleName(html: string): string | null {
  const m = html.match(/static\/js\/(main\.[a-z0-9]+\.js)/i);
  return m ? m[1] : null;
}

/** True only when both names are known and differ. */
export function isNewerVersion(running: string | null, live: string | null): boolean {
  return !!running && !!live && running !== live;
}

/** The main script this page is running, from its own <script> tags. */
export function runningBundleName(doc: Document = document): string | null {
  for (const s of Array.from(doc.querySelectorAll('script[src]'))) {
    const name = mainBundleName((s as HTMLScriptElement).getAttribute('src') || '');
    if (name) return name;
  }
  return null;
}

export async function liveBundleName(): Promise<string | null> {
  try {
    const res = await fetch(`/index.html?v=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return null;
    return mainBundleName(await res.text());
  } catch {
    return null;
  }
}
